export default {
  phone: '', //登录手机号
  userID: '', //uid
  COOK: '',
  realname: '', //用户姓名
  temServerTime: '', //服务器时间戳
  temClientTime: '', //本地时间戳用来效验服务器时间
  coinAllnum: 0, //用户金币总数
  userBadgeNum: 0, //用户徽章总数
  internal_users: false, //是否是内部用户
  isGhost: false, //是否是幽灵用户
  class_id: '',
  lesson_id: '',
  lesson_type: '',
  class_type: '',
  gradeIndex: 0,
  lessonIndex: 0,
  subjectIndex: 0,
  semesterIndex: 0,
  classYear: 0,
  classYearIndex: 0,
  selfGradeIndex: 0,
  selfLessonIndex: 0,
  selfSubjectIndex: 0,
  live_video_mp4_appoint_time: 0, //门店体验课预约时间
  exp_live_timeout: 20000, //门店体验课，直播延迟上限
  teacher_id: '',
  is_unread: 0, //消息未读标记
  course_id: 0,
  grade: '', //年级
  lastGrade: 1,
  subject: '', //学科
  teacher_avatar_url: '', //老师头像
  class_name: '', //班级名称
  lessonCoin: '', //课时金币总数
  apiLessonInState: 0, //进课状态 0初始值 1 进课成功 2进课失败
  wsLessonInState: 0,
  liveVideoUrlData: {
    lesson_id: '',
    live_video_url_type: '', //直播清晰度
    live_video_url_stream: '', //直播流地址运营商
    live_video_url: '', //直播地址
    live_video_type: '', //视频格式 rtmp,flv
    live_video_url_list: {}, //直播切换地址
  },
  video_freeze_time: 3, //学生端智能切流配置1,卡顿3次
  video_freeze_last: 60, //学生端智能切流配置2,60秒
  video_replay_time: 10, //回放视频误差检测
  ping_recv_timeout: 5, //新版长连接发送ping值几秒没收到回馈关闭长连接
  ping_time: 20000, //新版长连接发送ping值时间
  playbackData: '', //回放页面需要的数据,
  user_photo: '/static/img/common/defaultImg.png', //学生头像，
  defaultPhoto: '/static/img/common/defaultImg.png', //学生默认头像
  userHeadwear: '', //学生头饰
  imgBaseUrl:
    'http://zhuhuo-live-video-img.oss-cn-beijing.aliyuncs.com/images_resources/face/', //表情图片默认baseUrl
  banned_speak: '0', //是否禁言
  text_banned_speak: '0', //文字禁言
  bzr_text_banned: '0', //班主任文字禁言
  round_robin_interval: 60, //课时列表页轮训间隔时间
  httpStatus: 0, //http请求失败状态
  httpData: {}, //http请求失败的参数
  animation_dl_timeout: 5, //加载课件题超时时间
  animation_req_timeout: 10, //课件题用超时时间
  animation_req_retry: 3, //课件题用重试次数
  send_socket_data_recall: 3, //ACK补发时间配置
  get_msg_time: 4, //轮训间隔
  videoBg: '', //video页面背景颜色
  seiTime: 0,
  smallClassId: 0, //小班id
  smallClassName: '', //小班名称
  smallClassType: 0, //小班类型
  video_stream_load_timeout: 10, //视频加载超时时间
  send_socket_times: 1, //长连接补发次数
  online: true, //网络是否正常。默认正常
  protocol_switch: 0, //goIm是否开启的开关 0关 1开
  entrance_status: false, // 交互课件-小游戏在课堂直播首页的入口开关，true开，false关
  get_livemsg_addr_num: 10, //长连接重连N次不成功更换地址
  is_typewriting: -1, //键盘输入框是否显示标记
  newVersion: false, //是否需要 更新
  is_voice_question: 0, //是否有语音题
  connect_wheat: 0, //是否有语音连麦
  downloadKeJianZipUrls: '', //交互课件下载资源地址
  count_online_time_interval: 60, //观看视频时长埋点
  api_retry_wait: 2, //接口请求重试延迟
  lessonState: '', //课时上课状态
  isNoviceClass: false, //是否是新手体验课
  govideo: false, //直接进入直播页标识
  firstLogin: 0, //首次登陆 0-非首次登陆，1-首次登陆显示引导，2-不显示引导
  continuousRightConfig: '', //连对配置数据
  danmuStyleList: '', //弹幕特殊样式配置数据
  myDanmuStyleId: 0, //自己当前弹幕样式
  continuousNum: '', //连对数
  continuousLevel: '', //连对等级
  continuousRightBaseUrl: '', //连对资源资本路径
  rtcStatus: '0', //默认值为0，如果当前学生的客户端满足连麦条件，传值为1
  rtcRole: 1, // 连麦角色：0观众、1主播
  rtcAppId: '', //连麦id
  showCompose: false,
  giftSwitchUniqueId: '', //发送礼物UniqueId
  composeLessInfo: {}, // 组合课时页面数据
  isSlave: 0, //是否是副课
  voiceSoe: 'ifly', //语音评测服务商
  playbackQuestionTime: 10, //回放页题目默认消失时间
  rankRandTimeForClient: 4, //获取徽章接口需要随机随机延迟
  isContinuousRightSetting: 0, //是否开始连对
  barragePosition: 0, //弹幕位置
  fakeLive: false,
  domain_list_for_ping: {
    api: [
      'api-config.zhuhuotech.com',
      'api-live.zhuhuotech.com',
      'api-client-upload.zhuhuotech.com',
      'api-poll.zhuhuotech.com',
      'api-sso.zhuhuotech.com',
      'live-kejian.zhuhuotech.com',
      'bigdata-client.zhuhuotech.com',
    ],
    live: ['live-pull.zhuhuotech.com'],
  }, //设备检测域名列表
  // 如果是是录播课，课程地址用这个，兼回放课地址
  playbackUrl: '',
};



// WEBPACK FOOTER //
// ./src/store/defaultState.js